module.exports = __webpack_public_path__ + "img/fll-terminal-4-baggage-inspection.9a120982.png";